import { a as _defineProperty } from '../_rollupPluginBabelHelpers-D7BmOdxG.js';

class LocationUtil {
  constructor() {
    _defineProperty(this, "location", window.location);
  }
  replace(...args) {
    this.location.replace(...args);
  }
}
const location = new LocationUtil();

export { location as default };
//# sourceMappingURL=location.js.map
